import React from 'react';
import { Route, Switch } from "react-router-dom";
import AdminLoListingCalendar from './lo-listing-calendar/admin-lo-listing-calendar';

const AdminListingCalendar = () => {
  return (
    <Switch>
      <Route exact path="/listing-calendar">
        <AdminLoListingCalendar />
      </Route>
    </Switch>
  )
}

export default AdminListingCalendar;
